import { Component, Input } from '@angular/core';
import { TranslocoModule, TRANSLOCO_SCOPE } from '@jsverse/transloco';

@Component({
  selector: 'boels-total-products',
  templateUrl: './total-products.component.html',
  styleUrls: ['./total-products.component.scss'],
  imports: [TranslocoModule],
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: ['productList'],
    },
  ],
})
export class TotalProductsComponent {
  @Input() productCount: number;
}
